import { useQuery } from '@tanstack/react-query';
import { fetchQuestionBankSubTopicDetail } from '../services/questionBankTopicService';

export function useQuestionBankSubTopicDetail(params = {}, options = {}) {
  return useQuery({
    queryKey: ['questionBankSubTopicDetail', params],
    queryFn: async () => {
      const { payload } = await fetchQuestionBankSubTopicDetail(params);
      const subTopicDetail = payload?.sub_topic_detail || payload?.subTopicDetail || payload || null;

      return subTopicDetail
        ? {
            ...subTopicDetail,
            subTopicDetail,
          }
        : null;
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
}
